import keyBinder from './key-binder'

export default {
    'key-binder': keyBinder
}